(function(){
  // Fade-in on scroll
  var fades=document.querySelectorAll('.bl-fade');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
    fades.forEach(function(el){io.observe(el);});
    // Play videos only while visible (saves mobile data)
    var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){if(v.preload==='none'){v.preload='auto';}var p=v.play();if(p&&p.catch){p.catch(function(){});}}else{v.pause();}});},{threshold:.25});
    document.querySelectorAll('video[data-bl-autoplay]').forEach(function(v){vio.observe(v);});
  } else {
    fades.forEach(function(el){el.classList.add('is-in');});
  }
  // Delivery date estimate: 5-8 business days
  function addBiz(d,n){var x=new Date(d);var c=0;while(c<n){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6){c++;}}return x;}
  var fmt={month:'short',day:'numeric'};
  document.querySelectorAll('[data-bl-delivery]').forEach(function(el){
    var now=new Date();
    try{el.textContent=addBiz(now,5).toLocaleDateString('en-US',fmt)+' – '+addBiz(now,8).toLocaleDateString('en-US',fmt);}catch(e){}
  });
})();
